import * as React from "react"
import { ensureArray } from "@digits-shared/helpers/arrayHelper"
import moneyFlowHelper from "@digits-shared/helpers/moneyFlowHelper"
import type { TimeseriesValue } from "src/frontend/components/Shared/Layout/Components/Charts/toTimeseries"

export const useTimeseriesToDisplay = (
  timeseries: TimeseriesValue[] | undefined,
  selectedIndex: number | number[] | undefined
) =>
  React.useMemo(
    () =>
      timeseries &&
      (Array.isArray(selectedIndex)
        ? timeseries.filter((_, i) => selectedIndex.includes(i))
        : timeseries[selectedIndex ?? timeseries.length - 1]),
    [selectedIndex, timeseries]
  )

export const useTimeSeriesTotal = (
  timeseriesToDisplay: TimeseriesValue[] | TimeseriesValue | undefined
) =>
  React.useMemo(() => {
    if (!timeseriesToDisplay) return timeseriesToDisplay

    const values = ensureArray(timeseriesToDisplay)
    const zeroTotal = moneyFlowHelper.buildZeroMoneyFlow()
    return values.reduce((agg, v) => moneyFlowHelper.add(agg, v.moneyFlow), zeroTotal)
  }, [timeseriesToDisplay])
